import Vue from "vue";
import Vuex from "vuex";

import agents from "./agents.module";
import auth from "./auth.module";
import breadcrumbs from "./breadcrumbs.module";
import config from "./config.module";
import filters from "./filters.module";
import htmlClass from "./htmlclass.module";
import leads from "./leads.module";
import notes from "./notes.module";
import notifications from "./notifications.module";
import offers from "./offers.module";
import reminders from "./reminders.module";
import roles from "./roles.module";
import students from "./students.module";
import users from "./users.module";

import Definitions from "./definitions/_index";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    htmlClass,
    config,
    breadcrumbs,
    leads,
    users,
    reminders,
    roles,
    notes,
    offers,
    notifications,
    students,
    agents,
    filters,
    ...Definitions,
  },
});
